export const setLocalStorage = (name: string, data: any) => {
  return localStorage.setItem(name, JSON.stringify(data))
}

export const getLocalStorage = (name: string) => {
  try {
    const item = localStorage.getItem(name)
        return item ? JSON.parse(item) : null
  } catch (error) {
    console.error('Error parsing localStorage item:', error)
    return null
  }
}
